<app-header></app-header>
<ion-content fullscreen scrollY="false" class="padding content home-generic" layout="row">
    <app-rows></app-rows>
</ion-content>
<ion-footer></ion-footer>
